import axios from 'axios'

const state = {
  categories: [],
  currentCategory: null,
  loading: false,
  error: null
}

const mutations = {
  SET_CATEGORIES(state, categories) {
    state.categories = categories
  },
  SET_CURRENT_CATEGORY(state, category) {
    state.currentCategory = category
  },
  ADD_CATEGORY(state, category) {
    state.categories.push(category)
  },
  UPDATE_CATEGORY(state, updatedCategory) {
    const index = state.categories.findIndex(c => c._id === updatedCategory._id)
    if (index !== -1) {
      state.categories.splice(index, 1, updatedCategory)
    }
  },
  DELETE_CATEGORY(state, categoryId) {
    state.categories = state.categories.filter(c => c._id !== categoryId)
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  }
}

const actions = {
  async fetchCategories({ commit }) {
    commit('SET_LOADING', true)
    try {
      const response = await axios.get('/categories')
      commit('SET_CATEGORIES', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Erreur lors du chargement des catégories')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchCategory({ commit }, categoryId) {
    commit('SET_LOADING', true)
    try {
      const response = await axios.get(`/categories/${categoryId}`)
      commit('SET_CURRENT_CATEGORY', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Erreur lors du chargement de la catégorie')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async createCategory({ commit }, categoryData) {
    commit('SET_LOADING', true)
    try {
      const response = await axios.post('/categories', categoryData)
      commit('ADD_CATEGORY', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Erreur lors de la création de la catégorie')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async updateCategory({ commit }, { categoryId, categoryData }) {
    commit('SET_LOADING', true)
    try {
      const response = await axios.put(`/categories/${categoryId}`, categoryData)
      commit('UPDATE_CATEGORY', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Erreur lors de la mise à jour de la catégorie')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async deleteCategory({ commit }, categoryId) {
    commit('SET_LOADING', true)
    try {
      await axios.delete(`/categories/${categoryId}`)
      commit('DELETE_CATEGORY', categoryId)
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Erreur lors de la suppression de la catégorie')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  }
}

const getters = {
  allCategories: state => state.categories,
  currentCategory: state => state.currentCategory,
  isLoading: state => state.loading,
  error: state => state.error,
  getCategoryById: state => id => state.categories.find(c => c._id === id),
  getCategoriesByParent: state => parentId => 
    state.categories.filter(c => c.parent === parentId)
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} 